export const ErrorMessageLimitMap = {
  // Map with message types and truncation lengths for parsing errors
  message: 100,
  longMessage: 100,
  component: 20,
  statusCode: 3,
  errorNumber: 20,
  fatal: 5,
};

export const ContextRoutesMap = {
  citations: 'results.citations',
  substances: 'results.substances',
  reactions: 'results.reactions',
  tgitems: 'results.targets',
  dpitems: 'results.heatmap',
};

export const CatalystMock = {
  Default: 'Search',
  DefaultSection: 'Default',
  newPageEvent: 'newPage',
  prefix: 'rx2',
  PageData: {
    businessUnit: 'ELS:CM:ELSS',
    environment: 'prod',
    language: 'en',
    loadTime: '',
    loadTimestamp: null,
    name: '',
    type: 'NG-GP',
    productName: 'rx2',
    noTracking: 'false',
  },
  VisitorData: {
    accessType: '',
    accountId: '',
    industry: '',
    ipAddress: '',
    loginStatus: 'loggedOut',
    loginSuccess: 'false',
    sisId: '',
    userId: '',
  },
  SearchData: {
    advancedCriteria: '',
    criteria: '',
    currentPage: '',
    dataFormCriteria: '',
    facets: [
      {
        name: '',
        values: '',
      },
    ],
    refModuleType: 'home',
    resultsPerPage: '',
    resultsByType: [
      {
        name: '',
        results: '',
      },
    ],
    sortType: '',
    totalResults: '',
    type: '',
    withinContentCriteria: '',
    withinResultsCriteria: '',
  },
  PageNames: {
    'public.login': 'login',
    'public.register': 'pub:register',
    'public.register-finalize': 'pub:register-finalize',
    'private.register': 'register',
    'private.register-finalize': 'register-finalize',
    'public.organization': 'login:choicescreen',
    'public.institution': 'login:institution',
    'public.shiblogin': 'login:shibolethlogin',
    'public.register-bulk': 'registration_id_redemption',
    'main.dev': 'dev',
    'main.hopinto': 'query:hopinto',
    'main.search.quick.query': 'query:quicksearch',
    'main.search.advancedsearch': 'query:querybuilder',
    'main.structure': 'query:structureeditor',
    'main.search.quick.results': 'query:preview',
    'main.profile.account': 'profile:account',
    'main.profile.profile': 'profile:profile',
    'main.profile.preferences': 'profile:preferences',
    'results.substances': 'results:substances',
    'results.reactions': 'results:reactions',
    'results.citations': 'results:citations',
    'results.targets': 'results:targets',
    'results.heatmap': 'results:heatmap',
    'main.history': 'history:recent',
    'main.history.saved': 'history:saved',
    'main.history.recent': 'history:recent',
    'main.conditions': 'condition-navigator',
    'main.conditions.draw': 'query:structureeditor-conditions',
    'main.conditions.detail': 'condition-summary',
    'main.alerts': 'alerts',
    'main.alerts.old': 'alerts:old',
    'main.alerts.new': 'alerts:new',
    'public.redirect': 'redirect',
    'public.logout': 'logout',
  },
  Errors: {
    falseCharSearch: 'AE-INPUT:AE-UNEXPECTED_CHARACTER_SEARCH',
    falseFieldType: 'AE-INPUT:AE-FIELD_TYPE_IS_NOT_RECOGNISED',
    falseEntryMultiple: 'AE-INPUT:AE-SELECT_ONE_ENTRY',
    falseEntrySingle: 'AE-INPUT:AE-SELECT_AT_LEAST_ONE_ENTRY',
    falseSelectDoubleSearch: 'AE-INPUT:AE-SELECT_AT_LEAST_TWO_SEARCHES',
    falseSelectDateFormat: 'AE-INPUT:AE-DATA_FORMAT_IS_NOT_RECOGNISED',
    falseFieldCombination: 'AE-INPUT:AE-SUBHEADING_AND_FIELD_COMBINATION',
    falseMappingCombination: 'AE-INPUT:AE-MAPPING_AND_FIELD_COMBINATION',
    falseSearchQuery: 'AE-INPUT:AE-NO_SEARCH_QUERY_PROVIDED',
    falseTermProvided: 'AE-INPUT:AE-NO_EMTREE_TERM_PROVIDED',
    falseArticleDataProvided: 'AE-INPUT:AE-NO_ARTICLE_DATA_PROVIDED',
    falseAuthorProvided: 'AE-INPUT:AE-NO_AUTHOR_PROVIDED',
    falseSessionSearch: 'AE-INPUT:AE-SESSION_SEARCH_IS_NOT_RECOGNIZED',
    falseSaveSearch: 'AE-INPUT:AE-SAVED_SEARCH_IS_NOT_RECOGNIZED',
    falseEmailAddress: 'AE-INPUT:AE-SAVED_EMAIL_ADDRESS_IS_NOT_CORRECT',
    falseSubject: 'AE-INPUT:AE-EMPTY_SUBJECT',
    falseEmailAlertCount: 'AE-INPUT:AE-SELECT_AT_LEAST_ONE_EMAIL_ALERT',
    falseEmailAlertQueryCount: 'AE-INPUT:AE-INVALID_QUERY_FOR_EMAIL_ALERT_IMPORT',
    falseClipboardSelectCount: 'AE-INPUT:AE-SELECT_AT_LEAST_ONE_SAVED_CLIPBOARD',
    falseDeleteSearch: 'AE-INPUT:AE-CANNOT_DELETE_REFERRED_SEARCH',
    falsePageNumber: 'AE-INPUT:AE-WRONG_PAGE_NUMBER',
    falseCredentials: 'AE-INPUT:AE-WRONG_USERNAME_OR_PASSWORD',
    error500: 'SE-500:SE-500-500',
    error403: 'SE-400:SE-400-403',
    error404: 'SE-400:SE-400-404',
  },
};
